import {
  GET_PROFILE,
  GET_PROFILE_FAIL,
  GET_PROFILE_SUCCESS,
  UPDATE_PROFILE,
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILE_SUCCESS,
  RESET_PROFILE_STATE,
  UPDATE_USER_PWD,
  UPDATE_USER_PWD_SUCCESS,
  UPDATE_USER_PWD_FAIL,
} from "./actionTypes";

//company profile
export const getProfile = page => ({
  type: GET_PROFILE,
  payload: page,
});

export const getProfileSuccess = profile => ({
  type: GET_PROFILE_SUCCESS,
  payload: profile,
});

export const getProfileFail = error => ({
  type: GET_PROFILE_FAIL,
  payload: error,
});

//update profile
export const updateProfile = (payload) => ({
  type: UPDATE_PROFILE,
  payload: payload,
});

export const updateProfileSuccess = profile => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: profile,
});

export const updateProfileFail = error => ({
  type: UPDATE_PROFILE_FAIL,
  payload: error,
});

//update user password
export const updateUserPassword = (payload) => ({
  type: UPDATE_USER_PWD,
  payload: payload,
});

export const updateUserPasswordSuccess = payload => ({
  type: UPDATE_USER_PWD_SUCCESS,
  payload: payload,
});

export const updateUserPasswordFail = error => ({
  type: UPDATE_USER_PWD_FAIL,
  payload: error,
});

//reset
export const resetProfileState = () => {
  return {
    type: RESET_PROFILE_STATE,
  }
}


